export { toTableSbBlokData } from './to-table-sb-blok-data'
